import React from 'react';
import LinkType from '../../constants/LinkType';

interface Props {
  link: string;
  linkType: LinkType;
  customLinkText?: string;
  customTitle?: string;
  customLabel?: string;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}

const EveLink = ({ linkType, link, customLinkText, customTitle, customLabel, onClick }: Props): JSX.Element => {
  const determineLabel = (): string => {
    if (customLabel) {
      return customLabel;
    }
    if (linkType === LinkType.EMAIL) {
      return `Send an email to ${link}`;
    }
    const preface = `${linkType === LinkType.WEB ? 'Visit' : ''}${linkType === LinkType.DOCUMENT ? 'View' : ''}${
      linkType === LinkType.ARTICLE ? 'Read about' : ''
    }`;
    // Ideally, the user will add a customTitle. The description strength is up to them (- Be 508 Aware -).
    return `${preface} ${customTitle || customLinkText || link} in a new tab`;
  };

  return (
    <a
      href={linkType === LinkType.EMAIL ? `mailto:${link}` : link}
      aria-label={determineLabel()}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
    >
      {customLinkText || link}
    </a>
  );
};

EveLink.defaultProps = {
  customLinkText: undefined,
  customTitle: undefined,
  customLabel: undefined,
  onClick: undefined,
};

export default EveLink;
